import React, { useState, useEffect } from 'react';
import logoImage from './assets/logo1.png'; 

const Navbar = () => {
  const [activeSection, setActiveSection] = useState('');

  const scrollToSection = (id) => {
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
      setActiveSection(id);
    }
  };

  useEffect(() => {
    const sections = ['home', 'about', 'services', 'portfolio', 'contact'];

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setActiveSection(entry.target.id);
          }
        });
      },
      { threshold: 0.5 }
    );

    sections.forEach((id) => {
      const section = document.getElementById(id);
      if (section) {
        observer.observe(section);
      }
    });

    return () => {
      sections.forEach((id) => {
        const section = document.getElementById(id);
        if (section) {
          observer.unobserve(section);
        }
      });
    };
  }, []);

  const navItemStyle = (id) => ({
    margin: '0 15px', // 🔧 Increased horizontal gap between items
    cursor: 'pointer',
    color: activeSection === id ? 'grey' : 'darkblue',
  });

  return (
    <nav
      style={{
        background: '#FFFFFF',
        padding: '10px 50px',
        color: 'darkblue',
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        zIndex: 100,
        boxSizing: 'border-box',
      }}
    >
      <div
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <div
          style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
          onClick={() => scrollToSection('hero')}
        >
          <img
            src={logoImage}
            alt="Logo"
            style={{ height: '40px', marginRight: '10px' }}
          />
          <h2 style={{fontFamily: "'Courgette', cursive", margin: 0 }}>Sevenky Technologies Private Limited</h2>
        </div>

        <ul
          style={{
            listStyle: 'none',
            display: 'flex',
            flexWrap: 'wrap',
            margin: 0,
            padding: 0,
          }}
        >
          <li
            style={navItemStyle('home')}
            onClick={() => scrollToSection('home')}
          >
          Home
          </li>
          <li
            style={navItemStyle('about')}
            onClick={() => scrollToSection('about')}
          >
            About
          </li>
          <li
            style={navItemStyle('services')}
            onClick={() => scrollToSection('services')}
          >
            Services
          </li>
          <li
            style={navItemStyle('portfolio')}
            onClick={() => scrollToSection('portfolio')}
          >
            Portfolio
          </li>
          <li
            style={navItemStyle('contact')}
            onClick={() => scrollToSection('contact')}
          >
            Contact
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
